import React from "react";
import { Link, useLocation } from "react-router-dom";
import styled from "styled-components";
import { prop } from "styled-tools";

import Button from "components/base/Button";
import Icon from "components/Icon";

/*
 * Styles
 */

/* Explore */

const Explore = styled.div`
  border: 1px solid ${prop("theme.colors.grayT")};
  border-radius: 0.2rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  margin-top: 1.2rem;
  padding: 1.6rem;
  width: 100%;
  @media (min-width: 40em) {
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
  }
`;

const ExploreIcon = styled.div`
  border: 1px solid ${prop("theme.colors.blueT")};
  border-radius: 50%;
  color: ${prop("theme.colors.blue")};
  flex-shrink: 0;
  line-height: 2.2rem;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
  width: 2.2rem;
  @media (min-width: 40em) {
    font-size: ${prop("theme.scale.up1")};
    margin-left: 0;
    margin-right: 0.4rem;
  }
`;

/* Text */

const A = Button.withComponent(Link);

const H2 = styled.h2`
  color: ${prop("theme.colors.grayS")};
  font-family: ${prop("theme.fonts.heading")};
  font-size: ${prop("theme.scale.up1")};
  line-height: 2rem;
  margin: 0 0 1.2rem;
  text-align: center;
  @media (min-width: 40em) {
    font-size: ${prop("theme.scale.up1")};
    margin: auto auto auto 0;
    text-align: left;
  }
`;

/*
 * Component
 */

export default function ExplorerPromo() {
  const location = useLocation();
  const pathSegments = location.pathname.split("/");

  let localeSegment = "";

  if (pathSegments[1] === "uk") {
    localeSegment = "/uk";
  }

  return (
    <>
      <Explore>
        <ExploreIcon>
          <Icon id="explore" title="Explore" />
        </ExploreIcon>
        <H2>Explore All the Survey Results</H2>
        <A to={`${localeSegment}/data-explorer`}>Visit Data Explorer</A>
      </Explore>
      {localeSegment === "" && (
        <Explore>
          <ExploreIcon>
            <Icon id="profile" title="Profile" />
          </ExploreIcon>
          <H2>Create Your Own Group Survey</H2>
          <A to="/create-group-survey">Create Survey</A>
        </Explore>
      )}
    </>
  );
}
